import { CommonModule } from '@angular/common';
import { Component, WritableSignal, signal, input, output, inject, InputSignal, computed, Signal } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OnlyNumberDirective } from '../../directives/only-number.directive';
import { Router } from '@angular/router';
import { ProductCardService } from '../../product-card.service';
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { EmptyMessageComponent } from '../../empty-message/empty-message.component';

@Component({
    selector: 'app-addable-product-card',
    templateUrl: './addable-product-card.component.html',
    styleUrl: './addable-product-card.component.scss',
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        OnlyNumberDirective,
        NgbTooltip,
        EmptyMessageComponent
    ],
    providers: [ProductCardService]
})

export class AddableProductCard {
  productCardService = inject(ProductCardService);
  private router = inject(Router);

  stock: WritableSignal<any> = signal(null);
  isOOS: WritableSignal<boolean> = signal(false);
  isOOSPerQtty: WritableSignal<boolean> = signal(false);
  stockLimit: WritableSignal<number> = signal(1);
  oosMessage: Signal<string> = computed(() => {
    const isOOS = this.isOOS();
    const isOOSPQ = this.isOOSPerQtty();

    if (isOOS) return 'Product temporarily out of stock.';
    if (isOOSPQ) return 'Insufficient stock.'
    return ''
  })

  product: any = input(null, {
    transform: (product: any) => {
      const qtty = product?.quantity || 1;
      product.quantity = qtty;

      let availableQuantity = 10;
      let stockExitst = false;
      if (product.stock) {
        stockExitst = true;
        this.stock.set(product.stock);
        availableQuantity = product.stock.stock + (product.stock.limit * -1);
        this.stockLimit.set(availableQuantity > 0 ? availableQuantity : 1);
        if (availableQuantity <= 0)
          this.isOOS.set(true);
      }

      const availableQuantityArray = [];
      availableQuantity = availableQuantity === 10 && stockExitst ? 9 : availableQuantity > 10 ? 10 : availableQuantity;
      for (let index = 1; index <= availableQuantity; index++) {
        availableQuantityArray.push({
          id: index,
          text: index === 10 ? '+10' : index.toString()
        });
      }

      this.availableQuantity.set(availableQuantityArray);

      if (qtty >= 10)
        this.productCardService.wasValueHigher10.set(true);

      this.productCardService.newQuantity.set(product?.quantity);
      return product;
    }
  });

  isLimitedUser: InputSignal<boolean> = input(false);
  isLockedBundle: InputSignal<boolean> = input(false);
  isFixedBundle: InputSignal<boolean> = input(false);
  productKey: any = input(null)
  addItem = output<any>();
  removable: InputSignal<boolean> = input(false);
  removeItem = output<any>();
  changeQuantity = output<any>();

  availableQuantity: WritableSignal<{ id: number, text: string }[]> = signal([]);

  newQuantity = computed(() => {
    const quantity = this.productCardService.newQuantity();
    if (quantity) {
      return this.productCardService.newQuantity()
    }
    return 1
  });

  handleKeyUp(event: any) {
    this.productCardService.onKeyUp(event.value);
    this.#validateOOSPerQuantity();
    if (this.removable())
      this.changeQuantity.emit({ ...this.product(), validationQuantity: this.productCardService.newQuantity() - this.product().quantity, quantity: this.productCardService.newQuantity() })
  }

  handleChangeQuantitySelect(value: any) {
    this.productCardService.onChangeQuantitySelect(value);
    this.#validateOOSPerQuantity();
    if (this.removable())
      this.changeQuantity.emit({ ...this.product(), validationQuantity: this.productCardService.newQuantity() - this.product().quantity, quantity: this.productCardService.newQuantity() })
  }

  add() {
    const productMapped = { ...this.product(), quantity: this.productCardService.newQuantity() }
    this.addItem.emit(productMapped)
  }

  handleImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/images/product-placeholder.webp';
  }

  goToProduct() {
    if (!this.isLimitedUser())
      this.router.navigate(['/shop/' + this.product()?.productURL]);
  }

  remove() {
    const productMapped = { ...this.product() }
    this.removeItem.emit(productMapped)
  }

  #validateOOSPerQuantity() {
    const newqtty = this.productCardService.newQuantity();
    const stock = this.stock()?.stock || null;

    if (!stock) return

    const limit = this.stock().limit;


    const newStock = stock - newqtty + (limit * -1);
    this.isOOSPerQtty.set(newStock < 0);
  }
}
